import React, { useEffect, useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const LEVEL_COLORS = {
  excellent: "#4cd964",
  good: "#5ac8fa",
  okay: "#ffcc00",
  sad: "#ff9500",
  terrible: "#ff3b30",
};

const EmotionalLevelGraph = ({ apiResponses, startDate, endDate, text }) => {
  const getDatesInRange = (start, end) => {
    const dates = [];
    let cur = new Date(start);
    while (cur <= end) {
      dates.push(cur.toISOString().split("T")[0]);
      cur.setDate(cur.getDate() + 1);
    }
    return dates;
  };

  const categories = useMemo(() => getDatesInRange(startDate, endDate), [startDate, endDate]);

  const seriesData = useMemo(() => {
    return categories.map((date) => {
      const match = apiResponses.find((r) => r.createdTime && r.createdTime.startsWith(date));
      if (!match) return { y: 0, color: "#cccccc" };
      const level = match.baseEmotion || "";
      return { y: 1, color: LEVEL_COLORS[level] || "#35b400", name: level };
    });
  }, [apiResponses, categories]);

  const options = {
    chart: { type: "column", height: 200, margin: [10, 0, 50, 40], backgroundColor: "rgba(0,0,0,0)" },
    title: { text: "" },
    credits: { enabled: false },
    xAxis: {
      categories,
      labels: {
        style: { fontSize: "10px" },
        formatter() {
          const d = new Date(this.value);
          return `${d.getDate()} ${d.toLocaleString("default", { month: "short" })}`;
        },
      },
      lineWidth: 0,
    },
    yAxis: { title: { text: "" }, tickPositions: [0, 1], gridLineWidth: 0 },
    plotOptions: {
      column: { pointWidth: 10, borderRadius: 5, borderWidth: 0, colorByPoint: true },
    },
    series: [{ name: "Emotion", data: seriesData, showInLegend: false }],
    legend: { enabled: false },
  };

  return (
    <div className="emotional-graph-box">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

EmotionalLevelGraph.defaultProps = {
  apiResponses: [],
  startDate: new Date(),
  endDate: new Date(),
  text: "",
};

export default EmotionalLevelGraph;
